import CompanyProfile from './components/company-profile/CompanyProfile.vue';
import Home from './components/home/Home.vue';
import NotFound from './components/errors/NotFound.vue';
import ServerError from './components/errors/ServerError.vue';
import Accommodation from './components/accommodation/Accommodation.vue';
import FlightBookings from './components/flight-bookings/FlightBookings.vue';
import Transportation from './components/transportation/Transportation.vue';
import HotelInfo from './components/hotel-reservation/HotelInfo.vue';
import Event from './components/event/Event.vue';
import Resume from './components/resume/Resume.vue';
import Options, { options } from './enums/Options';
import ClientsArea from './components/clients-area/ClientsArea.vue';
import PrivacyPolicy from './components/privacy-policy/PrivacyPolicy.vue'
import UnderMaintenance from './components/shared/UnderMaintenance.vue';
import PrePostTours from './components/local-tour/PrePostTours.vue';

const eventOptionRoutes = options
	.filter(option => option.name !== Options.EVENT_PROMOTER_WEBSITE.name)
	.map(option => ({
		path: `/:shortName/${option.name}`,
		component: Event,
		name: option.name,
		props: true,
		meta: {eventHeader: true, eventOption: option},
	}));

export const routes = [
	{ path: '/404', component: NotFound, name: 'not-found'},
	{ path: '/500', component: ServerError, name: 'server-error'},
	{ path: '/calendar', component: Home, name: 'home', meta: {toolbarVariant: 'transparent'}},
	{ path: '/clients-area', component: ClientsArea, name: 'clients-area'},
	{ path: '/resume', component: Resume },
	{ path: '/accommodation', component: Accommodation, name: 'accommodation' },
	{ path: '/local-tours' },
	{ path: '/flight-bookings', component: FlightBookings, name: 'flight-bookings' },
	{ path: '/transportation', component: Transportation, name: 'transportation' },
	{
		path: '/pre-post-tours',
		component: PrePostTours,
		name: 'pre-post-tours',
		props: {bookingEnabled: false},
	},
	{ path: '/company-profile', component: CompanyProfile, name: 'company-profile' },
	{ path: '/privacy-policy', component: PrivacyPolicy },
	{ path: '/under-maintenance', component: UnderMaintenance, name: 'under-maintenance'},
	{
		path: '/:shortName/flight-reservation/:adults/:kids/:babies/:origin/:destination/:checkin/:checkout?',
		component: Event,
		name: 'flight-reservation',
		props: true,
		meta: {
			eventHeader: true,
			eventOption: Options.FLIGHT_REQUEST,
			eventOptionComponent: 'wooba-flight-reservation',
			passFlightReservationParams: true,
		},
	},
	{ path: '/:shortName/hotel-info/:hotelId', name: 'hotel-info', component: HotelInfo, props: true, meta: {eventHeader: true} },
	...eventOptionRoutes,
	{ path: '/:shortName', component: Event, name: 'event', props: true, meta: {eventHeader: true}},
	{ path: '/', redirect: '/calendar' },
	{ path: '*', redirect: { name: 'not-found' } }
];



// WEBPACK FOOTER //
// ./src/routes.js